import { Flag, useFeatureFlags } from '@previo/feature-flags'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { Routes } from '~/router/routes'

const checkWhatsAppFlag = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const ff = useFeatureFlags()
  await ff.waitForInit()

  if (ff.isEnabled(Flag.PMS_COMMUNICATION_WHATSAPP_ENABLED).value) {
    return next()
  }

  return next({
    name: Routes.GENERAL_NOT_FOUND,
    params: { pathMatch: to.path.substring(1).split('/') },
  })
}

export default checkWhatsAppFlag
